module.exports = __webpack_public_path__ + "img/hotel-600.435848ec.jpg";